import React from "react";
import {
  Search,
  Calendar,
  Users,
  Utensils,
  ArrowRight,
  Plus,
  RotateCcw,
  Settings,
  Users as UsersIcon,
  Edit,
  Mail,
  Link,
  CreditCard,
  ShoppingBag,
  History,
  FileText
} from "lucide-react";

export type TabIconTypes =
  | "search"
  | "bookings"
  | "waitlist"
  | "open"
  | "left"
  | "add"
  | "sync"
  | "manage"
  | "guests"
  | "preorders"
  | "payments"
  | "notes"
  | "messages"
  | "linked"
  | "history"
  | "documents";
type TabIconProps = {
  name: TabIconTypes;
};

export function TabIcon({ name }: TabIconProps) {
  const getIcon = () => {
    switch (name) {
      case "search":
        return <Search aria-hidden="true" />;
      case "bookings":
        return <Calendar aria-hidden="true" />;
      case "waitlist":
        return <Users aria-hidden="true" />;
      case "open":
        return <Utensils aria-hidden="true" />;
      case "left":
        return <ArrowRight aria-hidden="true" />;
      case "add":
        return <Plus aria-hidden="true" />;
      case "sync":
        return <RotateCcw aria-hidden="true" />;
      case "manage":
        return <Settings aria-hidden="true" />;
      case "guests":
        return <UsersIcon aria-hidden="true" />;
      case "preorders":
        return <ShoppingBag aria-hidden="true" />;
      case "payments":
        return <CreditCard aria-hidden="true" />;
      case "notes":
        return <Edit aria-hidden="true" />;
      case "messages":
        return <Mail aria-hidden="true" />;
      case "linked":
        return <Link aria-hidden="true" />;
      case "history":
        return <History aria-hidden="true" />;
      case "documents":
        return <FileText aria-hidden="true" />;
      default:
        return <Calendar aria-hidden="true" />;
    }
  };

  return (
    <div className="TabIcon text-center mx-auto p-1.5 h-8">
      <div className="TabIcon_Item TabIcon_FluentIcon flex items-center justify-center h-5 [&>svg]:w-5 [&>svg]:h-5 [&>svg]:fill-none [&>svg]:stroke-current [&>svg]:stroke-2">
        {getIcon()}
      </div>
    </div>
  );
}
